module.exports = __webpack_public_path__ + "img/img29.91c448cf.svg";